import ZoomInIcon from '@mui/icons-material/ZoomIn';
import React from 'react';
import {
  DASHBOARD_IMAGE_SIZE_MAX,
  DASHBOARD_IMAGE_SIZE_MIN,
} from '../../hooks/useDashboardImageSettings';

interface DashboardImageControlsProps {
  label: string;
  cropSize: number;
  onCropSizeChange: (value: number) => void;
  zoomEnabled: boolean;
  onToggleZoom: () => void;
}

export const DashboardImageControls: React.FC<DashboardImageControlsProps> = ({
  label,
  cropSize,
  onCropSizeChange,
  zoomEnabled,
  onToggleZoom,
}) => (
  <div className="forge-dashboard-image-controls" aria-label={`${label} image controls`}>
    <span>{cropSize}px</span>
    <input
      aria-label={`${label} crop size`}
      type="range"
      min={DASHBOARD_IMAGE_SIZE_MIN}
      max={DASHBOARD_IMAGE_SIZE_MAX}
      value={cropSize}
      onChange={(event) => onCropSizeChange(Number(event.target.value))}
    />
    <button
      type="button"
      className={zoomEnabled ? 'is-active' : ''}
      aria-pressed={zoomEnabled}
      aria-label={zoomEnabled ? `${label} zoom on hover on` : `${label} zoom on hover off`}
      onClick={onToggleZoom}
    >
      <ZoomInIcon />
      Zoom
    </button>
  </div>
);
